export const ArrowLeftDate = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.67586 0.292832C8.06638 0.683357 8.06638 1.31652 7.67586 1.70705L2.38296 6.99994L7.67586 12.2928C8.06638 12.6834 8.06638 13.3165 7.67586 13.707C7.28533 14.0976 6.65217 14.0976 6.26164 13.707L0.367709 7.81311C-0.0813904 7.36401 -0.081398 6.63587 0.367709 6.18677L6.26164 0.292832C6.65217 -0.0976921 7.28533 -0.0976921 7.67586 0.292832Z"
        fill="currentColor"
      />
    </svg>
  )
}
